import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  AccountVerify,
  Button,
  ButtonIcon,
  CheckBox,
  FormHeader,
  InputBox,
  SectionHeader,
  TopMenu,
} from "../../../components";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewAdsCompany,
  createNewEmailVerification,
  resendEmailVerification,
} from "../../AdsSignUp/services/adsSignup.service";
import { CheckValidity, setAdsSession } from "../../../utils";
import { EmailChangeModal, EmailVerificationModal } from "../../modal";
import {
  doneSubcriber,
  openEmailChangeModal,
  openEmailVerificationModal,
} from "../../AdsPlatform/redux/actions";
import { set } from "immutable";
import { Store } from "react-notifications-component";
import { createNewSubscription } from "./service/subscribe.service";

const Subscribe = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [isAccountVerified, setIsAccountVerified] = useState(false);
  const [isActiveTopic, setIsActiveTopic] = useState(false);

  const [company, setCompany] = useState("");
  const { isOpenEmailVerificationModal, isSubscriber } = useSelector(
    ({ adsUserReducer }) => adsUserReducer
  );
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    firstName: {
      key: "firstName",
      label: "First name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "ex : John",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    workingEmail: {
      key: "workingEmail",
      label: "Working email address",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "example@email.com",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { newsUser } = useSelector(({ consoleReducer }) => consoleReducer);

  const [chooseTopics, setChooseTopics] = useState({
    all: false,
    liveFeed: false,
    daySummary: false,
    monthlySummary: false,
  });

  // Handler to toggle any checkbox independently
  const handleToggle = (key) => {
    setChooseTopics((prev) => ({
      ...prev,
      [key]: !prev[key], // Just toggle the clicked one
    }));
  };

  // // Handler to toggle a single checkbox
  // const handleToggle = (key) => {
  //   setChooseTopics((prev) => ({
  //     ...prev,
  //     [key]: !prev[key],
  //     all: key === "all" ? !prev.all : false, // If not "all", make sure "all" becomes false
  //   }));
  // };

  // // Handle "All" selection (toggle all others)
  // const handleToggleAll = () => {
  //   setChooseTopics((prev) => {
  //     const newValue = !prev.all;
  //     return {
  //       all: newValue,
  //       liveFeed: newValue,
  //       daySummary: newValue,
  //       monthlySummary: newValue,
  //     };
  //   });
  // };

  const handleChange = async (event, inputIdentity) => {
    const updateSubScribeForm = {
      ...formData,
    };

    updateSubScribeForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateSubScribeForm[inputIdentity].value,
      updateSubScribeForm[inputIdentity].validation
    );

    if (validityRes) {
      updateSubScribeForm[inputIdentity].isValid = validityRes.isValid;
      updateSubScribeForm[inputIdentity].invalidReason = validityRes.reason;

      updateSubScribeForm[inputIdentity].touched = true;

      let formIsValid = false;
      for (let inputIdentifier in updateSubScribeForm) {
        formIsValid = updateSubScribeForm[inputIdentifier].valid && formIsValid;
      }
      setFormData(updateSubScribeForm);
    }
  };
  const updateInputValidationErrors = async () => {
    let df = { ...formData };
    let formIsValid = true;
    for (let itemKey of Object.keys(df)) {
      if (itemKey === "firstName" || itemKey === "firstName") {
        if (df[itemKey].value === "" || df[itemKey].invalidReason) {
          df[itemKey].touched = true;
          formIsValid = false;
        }
      }
    }
    await setFormData(df);
    return formIsValid;
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }
    setFormData(updateForm);
  };

  // const onClickResendEmailVerification = async () => {
  //   setIsLoading(true);
  //   try {
  //     if (signupUser) {
  //       let resVerify = await resendEmailVerification({
  //         company_id: signupUser?.company_id,
  //         email: signupUser?.working_email,
  //       });
  //       if (resVerify.data.status) {
  //         console.log("resVerify", resVerify.data);
  //         setAdsSession(resVerify.data?.data?.token);
  //         setIsLoading(false);
  //         setIsDisable(true);
  //       } else {
  //         notification.error({
  //           message: "Error",
  //           description: resVerify.data.message,
  //         });
  //         setIsLoading(false);
  //       }
  //     } else {
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Error resending email verification:", error);
  //     setIsLoading(false);
  //     notification.error({
  //       message: "Error",
  //       description: "Failed to resend verification email. Please try again.",
  //     });
  //   }
  // };

  // set a timer to automatically active resend button after 30 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDisable(false);
    }, 30000); // 30 seconds

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);

  const fetchEmail = (value) => {
    return value.replace(
      /^[ ]*([^@\s])([^@\s]*)(@(?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i,
      (_, firstChar, rest, domain) =>
        `${firstChar}${"*".repeat(rest.length)}${domain}`
    );
  };

  // const onClickAdd = async () => {
  //   setIsLoading(true);

  //   const updateSubScribeForm = { ...formData };

  //   let isValid = await updateInputValidationErrors();
  //   if (isValid) {
  //     try {
  //       const response = await createNewAdsCompany({
  //         company_name: updateSubScribeForm.firstName.value,
  //         working_email: updateSubScribeForm.workingEmail.value,
  //         password: "user@123",
  //         company_type: "subscribe_user",
  //       });
  //       setIsLoading(false);
  //       console.log("Subscription response:", response);

  //       if (
  //         response?.data?.status === false &&
  //         response?.data?.message?.includes("already exists.")
  //       ) {
  //         // Update form state to show validation error
  //         setFormData((prev) => ({
  //           ...prev,
  //           workingEmail: {
  //             ...prev.workingEmail,
  //             isValid: true,
  //             invalidReason: "This email is already registered.",
  //             touched: true,
  //           },
  //         }));
  //         return;
  //       }
  //       if (response?.data?.status) {
  //         // console.log("result", response?.data);
  //         if (!response?.data?.isAccountVerified) {
  //           setFormData((prev) => ({
  //             ...prev,
  //             workingEmail: {
  //               ...prev.workingEmail,
  //               isValid: true,
  //               invalidReason: "Please Verify Email.",
  //               touched: true,
  //             },
  //           }));
  //           setIsAccountVerified(true);
  //           setAdsSession(response?.data?.token);
  //           setCompany({
  //             user: response?.data?.data,
  //             token: response?.data?.token,
  //           });
  //           return;
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error creating subscribe-user:", error);
  //       setIsLoading(false);
  //     }
  //   } else {
  //     setIsLoading(false);
  //     console.error("error fill fields");
  //   }
  // };

  useEffect(() => {
    console.log("isSubscriber", isSubscriber);
    if (isSubscriber) {
      setIsAccountVerified(false);
      setIsActiveTopic(true);
      setFormData((prev) => ({
        ...prev,
        workingEmail: {
          ...prev.workingEmail,
          isValid: false,
          invalidReason: "",
          touched: false,
        },
      }));
      dispatch(doneSubcriber());
    }
  }, [isSubscriber]);

  const onClickCreate = async () => {
    setIsLoading(true);

    const updateSubScribeForm = { ...formData };

    let isValid = await updateInputValidationErrors();
    if (isValid) {
      try {
        const response = await createNewAdsCompany({
          company_name: updateSubScribeForm.firstName.value,
          working_email: updateSubScribeForm.workingEmail.value,
          password: "user@123",
          company_type: "subscribe_user",
        });
        setIsLoading(false);
        console.log("Subscription response:", response);

        if (
          response?.data?.status === false &&
          response?.data?.message?.includes("already exists.")
        ) {
          // Update form state to show validation error
          setFormData((prev) => ({
            ...prev,
            workingEmail: {
              ...prev.workingEmail,
              isValid: true,
              invalidReason: "This email is already registered.",
              touched: true,
            },
          }));
          return;
        }
        if (response?.data?.status) {
          // console.log("result", response?.data);
          setCompany({
            user: response?.data?.data,
            token: response?.data?.token,
          });

          if (!response?.data?.isAccountVerified) {
            setFormData((prev) => ({
              ...prev,
              workingEmail: {
                ...prev.workingEmail,
                isValid: true,
                invalidReason: "Please Verify Email.",
                touched: true,
              },
            }));
            setIsAccountVerified(true);

            return;
          }

          setAdsSession(response?.data?.token);
          console.log("end", response?.data?.token);
          setIsActiveTopic(true);

          // const body = {
          //   company_id: response.data.data.company_id,
          //   news_topic: chooseTopics,
          //   account_type: "unlimited",
          //   // subscribe_end_date: new Date(
          //   //   Date.now() + 7 * 24 * 60 * 60 * 1000 + 5.5 * 60 * 60 * 1000
          //   // ).toISOString(),
          // };

          // // console.log("subcribe body", body);

          // const res = await createNewSubscription(body);
          // console.log("Create Subscription response:", res);
          // setIsLoading(false);

          //   if (res?.data?.status) {
          //     Store.addNotification({
          //       title: "Success!",
          //       message: "Subscibe Create Successfully!",
          //       type: "success",
          //       insert: "top",
          //       container: "top-right",
          //       dismiss: { duration: 3000, onScreen: true },
          //     });
          //     setIsLoading(false);
          //     clearAll();
          //     // props.history.push("/ads/verification");
          //   }
          // } else {
          //   console.log("No data in response");
          // }
        }
      } catch (error) {
        console.error("Error creating subscribe-user:", error);
        setIsLoading(false);
        Store.addNotification({
          title: "Error!",
          message: "Failed to create subscribe-user. Please try again.",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      console.error("error fill fields");
    }
  };

  const onClickSubscribe = async () => {
    setIsLoading(true);

    const updateSubScribeForm = { ...formData };

    try {
      const body = {
        company_id: company?.user?.company_id,
        news_topic: chooseTopics,
        account_type: "unlimited",
        // subscribe_end_date: new Date(
        //   Date.now() + 7 * 24 * 60 * 60 * 1000 + 5.5 * 60 * 60 * 1000
        // ).toISOString(),
      };

      console.log("subcribe body", body);

      const res = await createNewSubscription(body);
      console.log("Create Subscription response:", res);
      setIsLoading(false);

      if (res?.data?.status) {
        console.log("complete subscribe", res);
        Store.addNotification({
          title: "Success!",
          message: "Subscibe Create Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        clearAll();
        props.history.push("/");
      } else {
        console.log("No data in response");
      }
    } catch (error) {
      console.error("Error creating subscription:", error);
      setIsLoading(false);
      Store.addNotification({
        title: "Error!",
        message: "Failed to create subscription. Please try again.",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (newsUser?.company_id && newsUser?.isAccountVerified) {
      setIsAccountVerified(false);
    }
  }, [newsUser]);

  const updateSubScribeForm = { ...formData };

  return (
    <>
      {isOpenEmailVerificationModal && <EmailVerificationModal />}

      <div className={"subscribe-wrapper"}>
        <div>
          <TopMenu
            data={{
              size: "sm",
              isLanguage: false,
              isLogo: false,
              isProfile: false,
            }}
          />
        </div>
        <div className={"sw__main-wrp"}>
          <div className={"sw__nagivator"}>
            <ButtonIcon
              data={{
                iconName: "h-wrrow-left",
                size: "md",
                type: "light",
              }}
              onClick={() => {
                props.history.push("/");
              }}
            />
            Back to home
          </div>
          <div className={"sw__form"}>
            <div className={"swf__header-wrapper"}>
              <div className={"swf__hw-logo"}>
                <img
                  src={require("../../../assets/img/lgo.png")}
                  alt={"logo"}
                />
              </div>
              <FormHeader
                data={{
                  formHeader: "Your News, Your Way - Subscribe & Take Control",
                  size: "sm-md",
                }}
              />
              <SectionHeader
                data={{
                  title: "First 100 users get a free pass for life!",
                  size: "xs-md",
                }}
              />

              <div className="swf_promo-wrapper">
                🎉 You're user #42 — You've unlocked lifetime free access!
              </div>
            </div>
            <div className={"swf__content"}>
              <InputBox
                data={updateSubScribeForm.firstName}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(
                    e.target.value,
                    updateSubScribeForm.firstName.key
                  );
                }}
              />

              {/* <div
                className="d-flex justify-content-end align-items-end mt-2"
                style={{
                  marginBottom: "-50px",
                  position: "relative",
                  zIndex: "90",
                }}
              >
                <div className="d-flex ml-2">
                  <Button
                    data={{
                      btnName: "Add",
                      buttonType: "secondary",
                      buttonSize: "md",
                      isLoading: isLoading,
                      disable: isDisable,
                    }}
                    onClick={async (e) => {
                      e.preventDefault();
                      await onClickAdd(e);
                    }}
                  />
                </div>
              </div> */}

              <InputBox
                data={updateSubScribeForm.workingEmail}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(
                    e.target.value,
                    updateSubScribeForm.workingEmail.key
                  );
                }}
              />
              {isAccountVerified && (
                <AccountVerify
                  data={{
                    title: "Please Verify Your Email.",
                    button: "Click here",
                  }}
                  onClick={async () => {
                    try {
                      // props.history.push("/profile-complete");
                      console.log({ company });
                      if (company?.user?.company_id) {
                        let resVerify = await createNewEmailVerification({
                          company_id: company?.user?.company_id,
                          email: company?.user?.working_email,
                        });
                        console.log("resVerify", resVerify.data);
                        if (resVerify.data.status) {
                          setAdsSession(resVerify.data?.data?.token);
                          setIsLoading(false);
                          dispatch(
                            openEmailVerificationModal({
                              user: company?.user,
                              token: resVerify.data?.data?.token,
                            })
                          );
                          // todo: dispatch function to mention subscriber
                          // setAdsSession(company?.token);
                          setIsLoading(false);
                        }
                      }
                    } catch (error) {
                      console.error(error);
                      notification.error({
                        message: "Error",
                        description: "Failed to load. Please try again.",
                      });
                    }
                  }}
                />
              )}

              {isActiveTopic && (
                <div className="swf-footer-wrapper">
                  <div className={"selector-lable"}>Choose topics you love</div>
                  <div className="swf-fw-select-box-wrapper ">
                    <CheckBox
                      data={{
                        checkName: "All",
                        isActive: chooseTopics.all,
                      }}
                      // onClick={() => {
                      //   setChooseTopics((prev) => ({
                      //     all: !prev.all,
                      //     liveFeed: false,
                      //     daySummary: false,
                      //     monthlySummary: false,
                      //   }));
                      // }}
                      onClick={() => handleToggle("all")}
                    />

                    <CheckBox
                      data={{
                        checkName: "Live Feed",
                        isActive: chooseTopics.liveFeed,
                      }}
                      // onClick={() => {
                      //   setChooseTopics((prev) => ({
                      //     all: false,
                      //     liveFeed: !prev.liveFeed,
                      //     daySummary: false,
                      //     monthlySummary: false,
                      //   }));
                      // }}
                      onClick={() => handleToggle("liveFeed")}
                    />
                    {/* </div> */}
                    {/* <div className="swf-fw-select-box-wrapper "> */}
                    <CheckBox
                      data={{
                        checkName: "Day Summary",
                        isActive: chooseTopics.daySummary,
                      }}
                      // onClick={() => {
                      //   setChooseTopics((prev) => ({
                      //     all: false,
                      //     liveFeed: false,
                      //     daySummary: !prev.daySummary,
                      //     monthlySummary: false,
                      //   }));
                      // }}
                      onClick={() => handleToggle("daySummary")}
                    />

                    <CheckBox
                      data={{
                        checkName: "Monthly Summary",
                        isActive: chooseTopics.monthlySummary,
                      }}
                      // onClick={() => {
                      //   setChooseTopics((prev) => ({
                      //     all: false,
                      //     liveFeed: false,
                      //     daySummary: false,
                      //     monthlySummary: !prev.monthlySummary,
                      //   }));
                      // }}
                      onClick={() => handleToggle("monthlySummary")}
                    />
                  </div>
                </div>
              )}
            </div>

            <Button
              data={{
                btnName: isActiveTopic ? "COMPLETE SUBSCRIBE" : "CREATE USER",
                buttonType:
                  updateSubScribeForm.firstName.value === "" ||
                  updateSubScribeForm.workingEmail.value === ""
                    ? "primary disabled"
                    : "primary",
                buttonSize: "lg",
                isLoading: isLoading,
                disable: isDisable,
              }}
              onClick={async (e) => {
                e.preventDefault(e);
                if (isActiveTopic) {
                  await onClickSubscribe();
                } else {
                  await onClickCreate();
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Subscribe);
